import React from 'react'
import { Container, Row, Col, Card } from 'react-bootstrap'
import { useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

function ScenarioWorkspace() {
  const { id } = useParams()
  const { t } = useTranslation()

  return (
    <Container>
      <Row className="mb-4">
        <Col>
          <h1>{t('scenario_workspace.title')}</h1>
          <p className="text-muted">
            {t('scenario_workspace.scenario_id', { id })}
          </p>
        </Col>
      </Row>

      <Row>
        <Col>
          <Card>
            <Card.Body>
              <Card.Title>{t('scenario_workspace.editor_title')}</Card.Title>
              <Card.Text>
                {t('scenario_workspace.editor_text')}
              </Card.Text>
              <ul>
                <li>{t('scenario_workspace.tab1')}</li>
                <li>{t('scenario_workspace.tab2')}</li>
                <li>{t('scenario_workspace.tab3')}</li>
                <li>{t('scenario_workspace.tab4')}</li>
                <li>{t('scenario_workspace.tab5')}</li>
              </ul>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

export default ScenarioWorkspace
